import { render } from "./BannerSection.vue?vue&type=template&id=2affef04&scoped=true"
import script from "./BannerSection.vue?vue&type=script&lang=js"
export * from "./BannerSection.vue?vue&type=script&lang=js"

import "./BannerSection.vue?vue&type=style&index=0&id=2affef04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2affef04"]])

export default __exports__